if (!window.Eurus.loadedScript.has('product-media.js')) {
  window.Eurus.loadedScript.add('product-media.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xProductMedia', (settings) => ({
        thumbnailOnMouseDown: false,
        thumbnailOfset: 0,
        thumbnailScrollOfset: 0,
        thumbnailGrabbingClass: '',
        thumbnailDidDrag: false,
        thumbnailStartX: 0,
        thumbnailStartY: 0,
        verticalRailRaf: null,
        verticalRailPending: 0,
        verticalWheelAcc: 0,
        verticalWheelAt: 0,
        verticalWheelStepAt: 0,
        zoomIsOpen: false,
        productMediaIsOpen: '',
        videoExternalListened: false,
        xPosition: 0,
        yPosition: 0,
        imageWidth: 0,
        imageHeight: 0,
        startZoom(event) {
          const elem = event.currentTarget;
          const size = elem.getBoundingClientRect();
          this.xOffset = size.left;
          this.yOffset = size.top;
          this.imageWidth = size.width;
          this.imageHeight = size.height;
        },
        updatePosition(event) {
          if (this.imageWidth && this.imageHeight) {
            this.xPosition = ((event.clientX - this.xOffset) / this.imageWidth) * 100;
            this.yPosition = ((event.clientY - this.yOffset)  / this.imageHeight) * 100;
          }
        },
        thumbnailHandleMouseDown(e) {
          this.thumbnailOnMouseDown = true;
          this.thumbnailGrabbingClass = 'cursor-grabbing';
          this.thumbnailDidDrag = false;
          this.thumbnailStartX = e.pageX;
          this.thumbnailStartY = e.pageY;
          if (settings.thumbnail_direction == 'horizontal') {
            this.thumbnailOfset = e.pageX - this.$refs.thumbnail.offsetLeft;
            this.thumbnailScrollOfset = this.$refs.thumbnail.scrollLeft;
          } else {
            const rail = this.$refs.thumbnail;
            if (rail.dataset.verticalSlider === 'true' && window.matchMedia('(min-width: 768px)').matches) {
              // Mandatory snap + smooth scroll-behavior fight every scrollTop write
              // during a drag (the browser re-snaps after each write and ends up
              // pinning the rail), so suspend both for the gesture —
              // _thumbnailRemoveGrabing restores them by settling on the nearest
              // thumbnail. Settle any in-flight glide too, so it can't fight the drag.
              this._railSettle(rail);
              rail.style.scrollSnapType = 'none';
              rail.style.scrollBehavior = 'auto';
              // Track the pointer at window level until release: the rail is only two
              // thumbnails tall, so a hold-and-push drag leaves it almost immediately —
              // element-level mousemove would stop firing and cap every drag at about
              // two images. (Inside the rail both listeners fire; the handler computes
              // an absolute position from e.pageY, so running twice is harmless.)
              const move = (ev) => this.thumbnailHandleMouseMove(ev);
              const up = () => {
                window.removeEventListener('mousemove', move);
                window.removeEventListener('mouseup', up);
                this._thumbnailRemoveGrabing();
              };
              window.addEventListener('mousemove', move);
              window.addEventListener('mouseup', up);
            }
            this.thumbnailOfset = e.pageY - rail.offsetTop;
            this.thumbnailScrollOfset = rail.scrollTop;
          }
        },
        thumbnailHandleMouseMove(e) {
          if(!this.thumbnailOnMouseDown) return;
          e.preventDefault();
          // Once the pointer has moved beyond a small slop, this gesture is a drag, not a
          // click — thumbnailHandleClickCapture uses this to swallow the click that would
          // otherwise fire on mouseup and select whichever thumbnail is under the pointer.
          if (Math.abs(e.pageX - this.thumbnailStartX) > 5 || Math.abs(e.pageY - this.thumbnailStartY) > 5) {
            this.thumbnailDidDrag = true;
          }
          if (settings.thumbnail_direction == 'horizontal') {
            const x = e.pageX - this.$refs.thumbnail.offsetLeft;
            const walk = (x - this.thumbnailOfset) * 2; 
            this.$refs.thumbnail.scrollLeft = this.thumbnailScrollOfset - walk;
          }
          else {
            const rail = this.$refs.thumbnail;
            const y = e.pageY - rail.offsetTop;
            const walk = (y - this.thumbnailOfset) * 2;
            let next = this.thumbnailScrollOfset - walk;
            if (rail.dataset.verticalSlider === 'true' && window.matchMedia('(min-width: 768px)').matches) {
              // Infinite drag with no clones: the moment the top thumbnail is fully
              // scrolled out, move it to the end of the list and pull the scroll
              // position (and the drag's reference offset) back by one step — the
              // remaining pixels are identical, so the rotation is invisible and the
              // gesture stays continuous. The mirror move covers dragging upward.
              // Rotation frees exactly the runway the drag consumes, so scrollTop
              // stays inside [0, step) and the rail loops forever in both directions.
              const step = parseFloat(rail.dataset.thumbStep) || 0;
              const count = parseInt(rail.dataset.thumbCount || '0', 10);
              if (step && count > 2) {
                while (next >= step) {
                  this._railRotate(rail, 1);
                  next -= step;
                  this.thumbnailScrollOfset -= step;
                }
                while (next < 0) {
                  this._railRotate(rail, -1);
                  next += step;
                  this.thumbnailScrollOfset += step;
                }
              }
            }
            rail.scrollTop = next;
          }
        },
        thumbnailHandleMouseLeave() {
          // A vertical-rail drag survives leaving the rail — the window-level
          // listeners registered on mousedown keep it alive until mouseup.
          const rail = this.$refs.thumbnail;
          if (
            this.thumbnailOnMouseDown &&
            rail && rail.dataset.verticalSlider === 'true' &&
            window.matchMedia('(min-width: 768px)').matches
          ) return;
          this._thumbnailRemoveGrabing();
        },
        thumbnailHandleMouseUp() {
          this._thumbnailRemoveGrabing();
        },
        // Runs in the capture phase, i.e. before theme.js's per-thumbnail click listener
        // (which is a normal bubble-phase listener on each .x-thumbnail). Stopping the event
        // here keeps a drag-released-over-a-thumbnail from ever reaching that listener, so
        // only a genuine, un-dragged click can call splide.go() and change the main image.
        thumbnailHandleClickCapture(e) {
          if (this.thumbnailDidDrag) {
            e.preventDefault();
            e.stopPropagation();
          }
          this.thumbnailDidDrag = false;
        },
        _thumbnailRemoveGrabing() {
          const wasDragging = this.thumbnailOnMouseDown;
          this.thumbnailOnMouseDown = false;
          this.thumbnailGrabbingClass = 'md:cursor-grab';
          if (!wasDragging) return;
          const rail = this.$refs.thumbnail;
          if (!rail || rail.dataset.verticalSlider !== 'true' || !window.matchMedia('(min-width: 768px)').matches) return;
          if (!this.thumbnailDidDrag) {
            // Plain click: nothing moved, just restore the snap/smooth styles the
            // mousedown suspended.
            rail.style.scrollSnapType = '';
            rail.style.scrollBehavior = '';
            return;
          }
          const step = parseFloat(rail.dataset.thumbStep) || 0;
          const count = parseInt(rail.dataset.thumbCount || '0', 10);
          if (!step || count < 2) {
            rail.style.scrollSnapType = '';
            rail.style.scrollBehavior = '';
            return;
          }
          // Settle the released drag on the nearest thumbnail boundary ourselves (snap
          // was suspended for the drag; the glide restores it when it finishes). The
          // drag handler keeps scrollTop inside [0, step), so the nearest boundary is
          // either 0 (glide back) or step (glide forward, then rotate that thumbnail
          // to the end so the rail is settled at 0 again).
          const nearest = Math.round(rail.scrollTop / step);
          if (nearest >= 1 && count > 2) {
            this.verticalRailPending = nearest;
            this._verticalAnimateTo(rail, nearest * step, () => this._railApplyPending(rail));
          } else {
            this._verticalAnimateTo(rail, 0);
          }
        },
        // Eases the rail to an exact scrollTop. Driven manually (not CSS
        // scroll-behavior:smooth) because mandatory scroll-snap makes native smooth scroll
        // settle early and unpredictably — which is why every step after the first used to
        // jump instead of glide. Retargetable: starting a new step mid-animation cancels the
        // old frame loop and continues from the current position, so rapid wheel notches
        // read as one continuous glide.
        _verticalAnimateTo(rail, target, onDone) {
          if (this.verticalRailRaf) cancelAnimationFrame(this.verticalRailRaf);
          rail.style.scrollSnapType = 'none';
          rail.style.scrollBehavior = 'auto';
          const startTop = rail.scrollTop;
          const duration = 350;
          const start = performance.now();
          const tick = (now) => {
            const p = Math.min(1, (now - start) / duration);
            const eased = 1 - Math.pow(1 - p, 3);
            rail.scrollTop = startTop + (target - startTop) * eased;
            if (p < 1) {
              this.verticalRailRaf = requestAnimationFrame(tick);
            } else {
              this.verticalRailRaf = null;
              // Run onDone (e.g. the invisible wraparound reset) while the inline
              // snap/behavior overrides are still active, so it can reposition instantly.
              if (onDone) onDone();
              rail.style.scrollSnapType = '';
              rail.style.scrollBehavior = '';
            }
          };
          this.verticalRailRaf = requestAnimationFrame(tick);
        },
        // Rotates the rail's DOM by one thumbnail: forward moves the first thumbnail
        // node to the end of the list, backward moves the last one to the front.
        // dataset.railStart tracks which media index the first DOM thumbnail now
        // represents, so scroll positions can always be translated back to media
        // indices. Rotation is how the rail loops with ONLY the product's real
        // images in the DOM — no cloned slides, ever: the caller re-anchors
        // scrollTop by one step in the same frame, so the swap is pixel-invisible.
        _railRotate(rail, direction) {
          const track = rail.firstElementChild;
          if (!track) return;
          const thumbs = track.querySelectorAll('.x-thumbnail');
          const count = thumbs.length;
          if (count < 2) return;
          const start = parseInt(rail.dataset.railStart || '0', 10);
          if (direction > 0) {
            track.appendChild(thumbs[0]);
            rail.dataset.railStart = (start + 1) % count;
          } else {
            track.insertBefore(thumbs[count - 1], thumbs[0]);
            rail.dataset.railStart = (start - 1 + count) % count;
          }
        },
        // Applies the rotations a finished forward glide owes (verticalRailPending) and
        // re-anchors the rail at scrollTop 0 — the settled state the whole rail keeps
        // returning to: first DOM thumbnail at the top, everything expressed from there.
        _railApplyPending(rail) {
          const k = this.verticalRailPending;
          this.verticalRailPending = 0;
          for (let i = 0; i < k; i++) this._railRotate(rail, 1);
          if (k > 0) rail.scrollTop = 0;
        },
        // Stops an in-flight glide and lands the rail on the nearest thumbnail boundary
        // immediately (at most half a step of visible jump). Used when a new gesture
        // (drag, thumbnail click, variant change) needs to take over from a glide.
        _railSettle(rail) {
          if (this.verticalRailRaf) {
            cancelAnimationFrame(this.verticalRailRaf);
            this.verticalRailRaf = null;
            rail.style.scrollSnapType = '';
            rail.style.scrollBehavior = '';
          }
          const step = parseFloat(rail.dataset.thumbStep) || 0;
          if (!step) return;
          const boundary = Math.round(rail.scrollTop / step);
          const owed = Math.min(boundary, this.verticalRailPending);
          this.verticalRailPending = 0;
          for (let i = 0; i < owed; i++) this._railRotate(rail, 1);
          rail.style.scrollBehavior = 'auto';
          rail.scrollTop = owed > 0 ? 0 : boundary * step;
          rail.style.scrollBehavior = '';
        },
        // Glides the rail so the thumbnail of media index `index` sits at the top —
        // theme.js' moveThumbnail delegates here (via rail._verticalGo) whenever the
        // main image changes. Chooses the short way around: forward glides use the
        // scroll runway then rotate; a wrap from the last image back to the first is
        // one backward rotation + a one-step glide, so it also reads as one move.
        verticalGoTo(rail, index) {
          const step = parseFloat(rail.dataset.thumbStep) || 0;
          const count = parseInt(rail.dataset.thumbCount || '0', 10);
          if (!step || count < 3) return;
          // The rotation math is sized for the desktop rail (two visible thumbnails);
          // on mobile the rail — when a merchant shows it — is a plain scroll list, so
          // keep it a plain scroll there.
          if (!window.matchMedia('(min-width: 768px)').matches) {
            const start = parseInt(rail.dataset.railStart || '0', 10);
            rail.scrollTop = (((index - start) % count + count) % count) * step;
            return;
          }
          this._railSettle(rail);
          const start = parseInt(rail.dataset.railStart || '0', 10);
          const p = ((index - start) % count + count) % count;
          if (p === 0) {
            if (rail.scrollTop !== 0) this._verticalAnimateTo(rail, 0);
            return;
          }
          if (p <= count - 2) {
            this.verticalRailPending = p;
            this._verticalAnimateTo(rail, p * step, () => this._railApplyPending(rail));
          } else {
            // Target is the thumbnail just "above" the current top: rotate it in from
            // the end (invisible — it enters above the viewport) and glide up to it.
            this._railRotate(rail, -1);
            rail.style.scrollBehavior = 'auto';
            rail.scrollTop += step;
            rail.style.scrollBehavior = '';
            this._verticalAnimateTo(rail, 0);
          }
        },
        // Same as verticalGoTo but instant — used to align the rail on load.
        _railJumpTo(rail, index) {
          const count = parseInt(rail.dataset.thumbCount || '0', 10);
          if (count < 3) return;
          this._railSettle(rail);
          const start = parseInt(rail.dataset.railStart || '0', 10);
          const p = ((index - start) % count + count) % count;
          for (let i = 0; i < p; i++) this._railRotate(rail, 1);
          rail.style.scrollBehavior = 'auto';
          rail.scrollTop = 0;
          rail.style.scrollBehavior = '';
        },
        // Moves the rail exactly one thumbnail per call — shared by the chevron and the
        // mouse wheel. It must never call splide.go(): stepping browses thumbnails, it
        // can't change the main image (only an explicit click on a thumbnail does that,
        // see thumbnailHandleClickCapture above).
        verticalStep(direction) {
          const rail = document.getElementById('x-product-thumbnail-' + settings.section_id);
          if (!rail) return;
          const step = parseFloat(rail.dataset.thumbStep) || 0;
          const count = parseInt(rail.dataset.thumbCount || '0', 10);
          // With two images the rail already shows both at once — nothing to browse.
          if (!step || count < 3) return;
          // The scroll runway below the two visible thumbnails; forward glides may only
          // queue as far as it reaches — the owed rotations reclaim it at glide end.
          const maxScroll = (count - 2) * step;
          if (direction > 0) {
            const target = (this.verticalRailPending + 1) * step;
            if (target > maxScroll + 0.5) return; // runway exhausted: absorb until the glide lands
            this.verticalRailPending += 1;
            this._verticalAnimateTo(rail, target, () => this._railApplyPending(rail));
          } else if (this.verticalRailPending > 0) {
            // Cancel a queued forward step first — retargeting the running glide keeps
            // quick wheel reversals feeling continuous.
            this.verticalRailPending -= 1;
            const target = this.verticalRailPending * step;
            this._verticalAnimateTo(rail, target, this.verticalRailPending > 0 ? () => this._railApplyPending(rail) : null);
          } else {
            // Rotate the previous thumbnail in above the viewport (invisible), then
            // glide up to it — backward looping without any clones either.
            if (rail.scrollTop + step > maxScroll + 0.5) return;
            this._railRotate(rail, -1);
            rail.style.scrollBehavior = 'auto';
            rail.scrollTop += step;
            rail.style.scrollBehavior = '';
            this._verticalAnimateTo(rail, 0);
          }
        },
        verticalSlideNext() {
          this.verticalStep(1);
        },
        // Turns free-wheeling into discrete steps: accumulate wheel deltas (normalised
        // across pixel/line/page delta modes), fire one step per notch-worth of scroll,
        // and let _verticalAnimateTo's retargeting keep every step smooth. Without this,
        // mandatory scroll-snap lets a single gesture fly past several thumbnails.
        verticalHandleWheel(e) {
          // Desktop-only layout; on mobile the rail is a horizontal carousel — leave
          // native scrolling alone.
          if (!window.matchMedia('(min-width: 768px)').matches) return;
          e.preventDefault();
          const now = performance.now();
          const gap = now - this.verticalWheelAt;
          this.verticalWheelAt = now;
          const unit = e.deltaMode === 1 ? 40 : e.deltaMode === 2 ? 400 : 1;
          const delta = e.deltaY * unit;
          if (!delta) return;
          // An event after a pause is a new, deliberate gesture — step immediately,
          // whatever the delta size. Pointer acceleration makes slow scrolling report
          // tiny deltas (single-digit px per notch on macOS), so any magnitude
          // threshold here leaves slow scrolling completely dead.
          if (gap > 150) {
            this.verticalWheelAcc = 0;
            this.verticalWheelStepAt = now;
            this.verticalStep(delta > 0 ? 1 : -1);
            return;
          }
          // Events under 150ms apart are the same gesture (fast spin, trackpad burst or
          // momentum tail): accumulate, and advance one step per notch-worth of scroll,
          // paced with the glide so a strong flick can't fly through the whole rail.
          this.verticalWheelAcc += delta;
          const notch = 100;
          if (Math.abs(this.verticalWheelAcc) < notch) return;
          if (now - this.verticalWheelStepAt < 300) {
            // Cooldown mid-gesture: hold (not discard) a full notch so the step fires
            // on the next event once the cooldown has passed — discarding here made
            // alternate notches vanish while spinning.
            this.verticalWheelAcc = Math.sign(this.verticalWheelAcc) * notch;
            return;
          }
          this.verticalWheelStepAt = now;
          const direction = this.verticalWheelAcc > 0 ? 1 : -1;
          this.verticalWheelAcc = 0;
          this.verticalStep(direction);
        },
        initVerticalThumbs() {
          const rail = document.getElementById('x-product-thumbnail-' + settings.section_id);
          if (!rail) return;
          const track = rail.firstElementChild;
          // The rail loops by rotating its real thumbnails (see _railRotate) — the DOM
          // only ever contains the product's actual media, one node per image.
          rail.dataset.railStart = rail.dataset.railStart || '0';
          if (track) {
            rail.dataset.thumbCount = track.querySelectorAll('.x-thumbnail').length;
          }
          // Single source of truth for the per-item scroll offset, read by theme.js'
          // moveThumbnail so the applied thumbnail height and the scroll math never drift apart.
          const apply = () => {
            let gap = 6;
            if (track) {
              const g = parseFloat(getComputedStyle(track).rowGap);
              if (!isNaN(g)) gap = g;
            }
            // Show exactly two secondary images at a time (rest scroll), like the reference.
            const h = Math.floor((rail.clientHeight - gap) / 2);
            rail.querySelectorAll('.x-thumbnail').forEach((t) => { t.style.height = h > 0 ? h + 'px' : ''; });
            rail.dataset.thumbStep = h > 0 ? h + gap : '';
          };
          // theme.js' moveThumbnail delegates rail positioning here so all of the
          // rotation bookkeeping lives in this file.
          rail._verticalGo = (index) => this.verticalGoTo(rail, index);
          const resync = () => {
            apply();
            const slider = document.getElementById('x-product-' + settings.section_id);
            if (slider && slider.splide) {
              this._railJumpTo(rail, slider.splide.index);
            }
          };
          apply();
          requestAnimationFrame(resync);
          window.addEventListener('resize', apply);
          document.addEventListener('eurus:media-gallery-ready:' + settings.section_id, resync);
        },
        zoomOpen(position, isSplide) {
          this.zoomIsOpen = true;
          Alpine.store('xPopup').open = true;
          setTimeout(() => {
            if (isSplide) {
              const splideEl = document.getElementById(`media-gallery-${settings.section_id}`)
              if (splideEl && splideEl.splide) {
                let nextSlideIndex = 0;
                const childrenArray = Array.from(splideEl.querySelector('.splide__list').children)
                childrenArray.map((item, index) => {
                  if (item.getAttribute('x-slide-index') == position) {
                    nextSlideIndex = index
                  }
                })
                splideEl.splide.go(nextSlideIndex);
              }
              document.addEventListener(`eurus:zoom-image-ready:${settings.section_id}`, () => {
                if (splideEl && splideEl.splide) {
                  let nextSlideIndex = 0;
                  const childrenArray = Array.from(splideEl.querySelector('.splide__list').children)
                  childrenArray.map((item, index) => {
                    if (item.getAttribute('x-slide-index') == position) {
                      nextSlideIndex = index
                    }
                  })
                  splideEl.splide.go(nextSlideIndex);
                }
              });
            }
            else {
              document.getElementById(position + '-image-zoom-' + settings.section_id).scrollIntoView({ behavior: 'smooth', block: 'start' })
            }
          }, 200);
          Alpine.store('xModal').activeElement = 'product-image-' + settings.section_id + '-' + position;
        },
        zoomClose() {
          this.zoomIsOpen = false;
          Alpine.store('xPopup').close();
        },
        
        videoHandleIntersect() {
          if (settings.video_autoplay) {
            Alpine.store('xVideo').play(this.$el);
          }
        },
        productModelInit() {
          window.Shopify.loadFeatures([
            {
              name: 'shopify-xr',
              version: '1.0',
              onLoad: this._productModelSetupShopifyXR,
            },
          ]);
        },
        _productModelSetupShopifyXR() {
          const setup = () => {
            document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
              window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
              modelJSON.remove();
            });
            window.ShopifyXR.setupXRElements();
          }
  
          if (!window.ShopifyXR) {
            document.addEventListener('shopify_xr_initialized', () => {
              setup();
            });
            return;
          }
      
          setup();
        },
        productModelLoadMedia() {
          let container = this.$el.parentNode;
          const content = document.createElement('div');
          content.appendChild(container.querySelector('template').content.firstElementChild.cloneNode(true));
  
          this.$el.classList.add('hidden');
          container.appendChild(content.querySelector('model-viewer'));
  
          this._productModelLoadViewerUI();
        },
        productModelPauseViewer() {
          if (this.$el.modelViewerUI) this.$el.modelViewerUI.pause();
        },
        _productModelLoadViewerUI() {
          window.Shopify.loadFeatures([
            {
              name: 'model-viewer-ui',
              version: '1.0',
              onLoad: this._productModelSetupViewerUI.bind(this),
            },
          ]);
        },
        _productModelSetupViewerUI(errors) {
          if (errors) return;
  
          this.$el.parentNode.modelViewerUI
            = new Shopify.ModelViewerUI(this.$el.parentNode.querySelector('model-viewer')); 
        }
      }));
    });
  });
}